import { useQuery } from '@tanstack/react-query';
import { executeAppAction, BASE_URL } from '@/services/DataService';
import { toastError } from '@strivelabs/ui-core';
import type { DataTableClientContent } from '@/types/ui-blocks';

export interface TimeTravelMetricsParams {
  google_ads_dataset_id: string;
  campaign_id: string;
  current_period_start_date: string;
  current_period_end_date: string;
  baseline_period_start_date: string;
  baseline_period_end_date: string;
}

export function useTimeTravelMetrics(
  params: TimeTravelMetricsParams | null,
  enabled: boolean
) {
  return useQuery<DataTableClientContent | null>({
    queryKey: [
      'timeTravelMetrics',
      params?.google_ads_dataset_id,
      params?.campaign_id,
      params?.current_period_start_date,
      params?.current_period_end_date,
      params?.baseline_period_start_date,
      params?.baseline_period_end_date,
    ],
    queryFn: async () => {
      if (!params) return null;

      try {
        const result = await executeAppAction(
          BASE_URL,
          'google_ads_campaign_analyzer_insight',
          'fetch_time_travel_metrics',
          [],
          [params]
        );

        // Response shape: { status, items: [{ data: { time_travel_metrics: { type, content } }, scenario }] }
        const block = result?.items?.[0]?.data?.time_travel_metrics;

        if (block?.type === 'data_table_client' && block.content) {
          return block.content as DataTableClientContent;
        }

        return null;
      } catch {
        toastError('Failed to fetch custom date metrics. Using original data.');
        return null;
      }
    },
    enabled: enabled && !!params,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
}
